export const APP_VERSION = process.env.REACT_APP_QA_MOBILE_APP_VERSION || '1.710.0';

export function getCleanAppVersion() {
    return APP_VERSION.split('-')[0];
}